import ITableCol from '@/interfaces/ITableCol';
import IMultiSelectItem from '@/interfaces/selects/IMultiSelectItem';

function listOfTableFieldsForSelection (tableColumns: ITableCol[], selectedTableColumns:IMultiSelectItem[]) {
    if (tableColumns) {
        const columnsIds = selectedTableColumns.map((el: IMultiSelectItem) => el.value);
        return tableColumns.filter((el: any) => columnsIds.includes(el.key));
    } else {
        return tableColumns;
    }
}

export default listOfTableFieldsForSelection;